export default class DataRouter {
    constructor(s, r, p) {
        this._setter = s;
        this._routes = r;
        this._parsers = p;
        this._prev = {};
        this._triggers = new Map();
        this._sources = new Map();
        this._routes.forEach(a => {
            a.in.forEach(k => {
                const arr = this._triggers.get(k) || [];
                arr.push(a);
                this._triggers.set(k, arr);
            });
            a.out.forEach(k => {
                const h = this._sources.get(k) || {};
                a.in.forEach(i => (h[i] = true));
                this._sources.set(k, h);
            });
        });
        this._routes.forEach(a => {
            a.length = Math.max(...a.in.map(key => _calckSize(key, this._sources, 1)));
        });
    }
    init(cfg) {
        const next = {};
        for (const key in cfg) {
            if (this._prev[key] !== cfg[key]) {
                const parser = this._parsers[key];
                next[key] = parser
                    ? parser(cfg[key])
                    : cfg[key];
            }
        }
        this._prev = this._prev ? { ...this._prev, ...cfg } : { ...cfg };
        this.setState(next);
    }
    setState(updates, ctx) {
        this._setter(updates);
        const needExec = !ctx;
        ctx = ctx || [];
        for (const key in updates) {
            const trgs = this._triggers.get(key);
            if (trgs) {
                trgs.forEach(a => {
                    if (ctx.indexOf(a) == -1) {
                        ctx.push(a);
                    }
                });
            }
        }
        if (needExec) {
            this._execNext(ctx);
        }
    }
    _execNext(ctx) {
        while (ctx.length) {
            ctx.sort((a, b) => (a.length < b.length ? 1 : -1));
            const next = ctx[ctx.length - 1];
            ctx.splice(ctx.length - 1);
            next.exec(ctx);
        }
    }
}
function _calckSize(key, sources, prev) {
    const next = sources.get(key);
    if (!next)
        return prev;
    const sizes = Object.keys(next).map(a => _calckSize(a, sources, prev + 1));
    return Math.max(...sizes);
}
//# sourceMappingURL=DataRouter.js.map